"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _reduxActions = require("redux-actions");

var _constants = require("./constants");

var C = _interopRequireWildcard(_constants);

var _constants2 = require("../reportDetail/constants");

var CReportDetail = _interopRequireWildcard(_constants2);

var _auth = require("../../../reducers/auth");

var _lodash = require("lodash");

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _reactRefetch = require("react-refetch");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    reports: null,
    latestReportDefinitions: Array(),
    reportDefinitions: Array(),
    reportDefinitionByIdState: null,
    latestReportDefinitionsState: null
};
function replaceByUid(list, newEl) {
    var found = false;
    var newList = list.map(function (el) {
        if (el.uid === newEl.uid) {
            found = true;
            return newEl;
        } else {
            return el;
        }
    });
    return found ? newList : newList.concat(newEl);
}
var insertReportDefinitions = function insertReportDefinitions(state, reportDefinitions) {
    var mergedReportDefinitions = reportDefinitions.reduce(replaceByUid, state.reportDefinitions);
    return Object.assign({}, state, {
        reportDefinitions: mergedReportDefinitions
    });
};
var handleReports = function handleReports(state, action) {
    return Object.assign({}, state, {
        reports: action.payload
    });
};
var handleReport = function handleReport(state, action) {
    var updatedReport = action.payload.value;
    if (state.reports === null || updatedReport === null) {
        return state;
    }
    var newReports = replaceByUid(state.reports.value, updatedReport);
    return Object.assign({}, state, {
        reports: _reactRefetch.PromiseState.resolve(newReports, state.reports.meta)
    });
};
var removeReport = function removeReport(state, action) {
    if (state.reports === null) {
        return state;
    }
    var newReports = (0, _lodash.filter)(state.reports.value, function (r) {
        return r.uid !== action.payload;
    });
    return Object.assign({}, state, {
        reports: _reactRefetch.PromiseState.resolve(newReports, state.reports.meta)
    });
};
var handleReportDefinitionByIdState = function handleReportDefinitionByIdState(state, action) {
    if (action.payload.value) {
        state = insertReportDefinitions(state, [action.payload.value]);
    }
    return Object.assign({}, state, {
        reportDefinitionByIdState: action.payload
    });
};
var handleLatestReportDefinitionsState = function handleLatestReportDefinitionsState(state, action) {
    var latestReportDefinitions = Array();
    if (action.payload.value) {
        state = insertReportDefinitions(state, action.payload.value);
        latestReportDefinitions = action.payload.value;
    }
    return Object.assign({}, state, {
        latestReportDefinitionsState: action.payload,
        latestReportDefinitions: latestReportDefinitions
    });
};
exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, C.REPORTS_LIST, handleReports), _defineProperty(_handleActions, C.REPORTS_LIST_FAILED, handleReports), _defineProperty(_handleActions, C.REPORTS_LIST_SUCCESS, handleReports), _defineProperty(_handleActions, C.REPORTS_LIST_DISMISS_ERROR, function (state, action) {
    return Object.assign({}, state, {
        reports: action.payload
    });
}), _defineProperty(_handleActions, C.REPORTS_GET_SUCCESS, handleReport), _defineProperty(_handleActions, C.REPORTS_REMOVE, removeReport), _defineProperty(_handleActions, C.REPORTS_DEFINITION, handleReportDefinitionByIdState), _defineProperty(_handleActions, C.REPORTS_DEFINITION_FAILED, handleReportDefinitionByIdState), _defineProperty(_handleActions, C.REPORTS_DEFINITION_SUCCESS, handleReportDefinitionByIdState), _defineProperty(_handleActions, C.REPORTS_DEFINITION_DISMISS_ERROR, function (state, action) {
    return Object.assign({}, state, {
        reportDefinitionByIdState: action.payload
    });
}), _defineProperty(_handleActions, C.REPORTS_DEFINITIONS_LATEST, handleLatestReportDefinitionsState), _defineProperty(_handleActions, C.REPORTS_DEFINITIONS_LATEST_FAILED, handleLatestReportDefinitionsState), _defineProperty(_handleActions, C.REPORTS_DEFINITIONS_LATEST_SUCCESS, handleLatestReportDefinitionsState), _defineProperty(_handleActions, C.REPORTS_DEFINITIONS_DISMISS_ERROR, function (state, action) {
    return Object.assign({}, state, {
        latestReportDefinitionsState: action.payload
    });
}), _defineProperty(_handleActions, CReportDetail.REPORTDETAILS_UPDATE_REPORT_SUCCESS, function (state, action) {
    var updatedReport = (0, _selectn2.default)("value", action.payload);
    if (updatedReport && state.reports) {
        var reportIndex = (0, _lodash.findIndex)(state.reports.value, function (report) {
            return report.uid === updatedReport.uid;
        });
        if (reportIndex) {
            var promiseState = state.reports;
            promiseState.value[reportIndex] = updatedReport;
            return Object.assign(state, {
                reports: promiseState
            });
        }
    }
    return state;
}), _defineProperty(_handleActions, _auth.AUTH_GLOBAL_SECURITY_ERROR, function (state, action) {
    return Object.assign({}, initialState);
}), _defineProperty(_handleActions, _auth.AUTH_LOGOUT, function (state, action) {
    return Object.assign({}, initialState);
}), _handleActions), initialState);
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/reports/index.ts
 ** module id = 1297
 ** module chunks = 0
 **/